<template>
  <div class="app-container log">
    <div>
      <el-tabs class="log-tab" tab-position="left" type="card" v-model="tabName" @tab-click="handleClick">
        <el-tab-pane label="打印记录" name="print"></el-tab-pane>
        <!-- <el-tab-pane label="取号日志" name="fetch"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="log-content">
      <print-log ref="printLog" v-if="tabName == 'print'" />
      <fetch-log ref="fetchLog" v-if="tabName == 'fetch'" />
    </div>
  </div>
</template>
<script>
import printLog from "@/components/actionlog/printLog/index";
import fetchLog from "@/components/actionlog/fetchLog/index";

export default {
  name: "printandship",
  components: { printLog, fetchLog },
  data() {
    return {
      tabName: "print",
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$refs[this.tabName + "Log"].getData();
    },
    handleClick(e) {
      this.$nextTick(() => {
        this.getData();
      });
    },
  }
}
</script>
<style lang="scss">
.log {
  display: flex;

  .log-tab {
    .el-tabs__nav {
      border-bottom: none !important;
    }
  }

  .log-content {
    // margin-left: 10px;
    width: calc(100% - 107px);
  }
}
</style>